import { render, staticRenderFns } from "./foodDetail.vue?vue&type=template&id=5f6d26ea&scoped=true"
import script from "./foodDetail.vue?vue&type=script&lang=js"
export * from "./foodDetail.vue?vue&type=script&lang=js"
import style0 from "./foodDetail.vue?vue&type=style&index=0&id=5f6d26ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6d26ea",
  null
  
)

export default component.exports